import React,{useState} from 'react'
import EmployeeForm from './EmployeeForm';
import EmployeeListview from './EmployeeListview';

const EmployeeDetails = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");


return (
  <>
    {fromIsShown ? (
        <EmployeeForm addForm={setFromIsShown} update={upData} sId={serviceId} />
      ) : (
        <EmployeeListview addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
)
}

export default EmployeeDetails